import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import Dialog from 'material-ui/Dialog';
import RaisedButton from 'material-ui/RaisedButton';
import Snackbar from 'material-ui/Snackbar';
import { activateTeamMember, deactivateTeamMember, getTeamMemberDetails, resendInvite, revokeUserInvite } from 'redux/modules/teamManagement';
import { getOrganizationUserDetails } from 'redux/modules/organization';
import Helmet from 'react-helmet';
import moment from 'moment';
import { ModalTopBar, PageHeader, Spinner } from 'components';
import * as styles from './OrgUserDetail.scss';
var OrgUserDetail = (_dec = connect(function (state) {
  return {
    organization: state.organization.current,
    theme: state.theme,
    isPending: state.organization.orgUserDetail && state.organization.orgUserDetail.orgStatus === 'PENDING',
    orgUserDetail: state.organization.orgUserDetail
  };
}, {
  activateTeamMember: activateTeamMember,
  deactivateTeamMember: deactivateTeamMember,
  getTeamMemberDetails: getTeamMemberDetails,
  resendInvite: resendInvite,
  revokeUserInvite: revokeUserInvite,
  getOrganizationUserDetails: getOrganizationUserDetails
}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(OrgUserDetail, _Component);

  var _super = _createSuper(OrgUserDetail);

  function OrgUserDetail(props) {
    var _this;

    _classCallCheck(this, OrgUserDetail);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleModalClose", function () {
      _this.setState({
        showRemoveConfirmModal: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleReactivate", function () {
      _this.props.activateTeamMember(_this.props.orgUserDetail.id, _this.props.organization.id);

      browserHistory.push({
        pathname: "/org/".concat(_this.props.organization.id, "/settings/users")
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleResendInvite", function () {
      _this.setState({
        sendingInvitation: true
      });

      _this.props.resendInvite(_this.props.organization.id, _this.props.orgUserDetail.id).then(function () {
        _this.setState({
          sendingInvitation: false,
          showSnackbar: true,
          snackbarMessage: 'Invitation successfully re-sent'
        });
      })["catch"](function (err) {
        console.error(err);

        _this.setState({
          showSnackbar: true,
          snackbarMessage: 'A problem occurred, please try again later.'
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleRevokeInvite", function () {
      _this.setState({
        revokingInvitation: true
      });

      _this.props.revokeUserInvite(_this.props.orgUserDetail.id, _this.props.organization.id).then(function () {
        _this.setState({
          revokingInvitation: false,
          showSnackbar: true,
          snackbarMessage: 'Invitation revoked.'
        }, function () {
          browserHistory.push({
            pathname: "/org/".concat(_this.props.organization.id, "/settings/users")
          });
        });
      })["catch"](function (err) {
        console.error(err);

        _this.setState({
          showSnackbar: true,
          snackbarMessage: 'A problem occurred, please try again later.'
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleRemoveBtnClick", function () {
      _this.setState({
        removingUser: true
      });

      _this.props.deactivateTeamMember(_this.props.orgUserDetail.id, _this.props.organization.id).then(function () {
        _this.setState({
          removingUser: false
        }, function () {
          browserHistory.push({
            pathname: "/org/".concat(_this.props.organization.id, "/settings/users")
          });
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderTeamMemberDetails", function (details) {
      return /*#__PURE__*/React.createElement("div", {
        className: styles.topWrap
      }, details.avatarUrl && /*#__PURE__*/React.createElement("div", {
        style: {
          backgroundImage: "url(".concat(details.avatarUrl, ")")
        },
        className: styles.avatar
      }), /*#__PURE__*/React.createElement("div", {
        className: styles.nameWrap,
        style: details.avatarUrl ? {
          marginLeft: 16,
          marginTop: 16
        } : {}
      }, /*#__PURE__*/React.createElement(PageHeader, {
        primary: details.name,
        style: {
          marginBottom: 8
        }
      }), /*#__PURE__*/React.createElement("span", {
        className: styles.belowName
      }, details.email)), /*#__PURE__*/React.createElement("div", {
        className: styles.topWrapRight
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.rightText
      }, /*#__PURE__*/React.createElement("span", {
        style: {
          fontWeight: 'bold'
        }
      }, "Join Date: "), /*#__PURE__*/React.createElement("span", null, moment(details.joinDate).format('MMM D, YYYY'))), _this.props.isPending ? /*#__PURE__*/React.createElement("div", {
        className: styles.rightButtonGroup
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.rightButton
      }, /*#__PURE__*/React.createElement(RaisedButton, {
        secondary: true,
        disabled: _this.state.sendingInvitation,
        label: "Re-send Invitation",
        onClick: _this.handleResendInvite
      })), /*#__PURE__*/React.createElement("div", {
        className: styles.rightButton
      }, /*#__PURE__*/React.createElement(RaisedButton, {
        label: "Cancel Invitation",
        onClick: _this.handleRevokeInvite,
        disabled: _this.state.revokingInvitation
      }))) : '', details.orgStatus === 'INACTIVE' && /*#__PURE__*/React.createElement("div", {
        className: styles.rightButton
      }, /*#__PURE__*/React.createElement(RaisedButton, {
        label: "Reactivate",
        onClick: _this.handleReactivate
      }))));
    });

    _this.state = {
      showRemoveConfirmModal: false,
      showSnackbar: false,
      sendingInvitation: false,
      revokingInvitation: false,
      removingUser: false
    };
    return _this;
  }

  _createClass(OrgUserDetail, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      console.log('componentWillMount in OrgUserDetail');
      this.props.getOrganizationUserDetails(this.props.organization.id, this.props.params.userId);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      console.log('render in OrgUserDetail');
      var haveRightDetails = false;
      var details = false;

      if (this.props.orgUserDetail) {
        // Redux store may have a clientDetail already - confirm that we have the details for the current org
        haveRightDetails = this.props.orgUserDetail.id == this.props.params.userId;

        if (haveRightDetails) {
          details = this.props.orgUserDetail;
        }
      }

      console.log(details);
      var modalBodyContent = null;

      if (this.state.showRemoveConfirmModal) {
        modalBodyContent = /*#__PURE__*/React.createElement("div", {
          className: styles.modalBodyContent
        }, /*#__PURE__*/React.createElement("p", null, "You are about to remove ", this.props.orgUserDetail.name, " from your team."));
      }

      var modalActions = [/*#__PURE__*/React.createElement(RaisedButton, {
        label: "Cancel",
        onClick: this.handleModalClose,
        style: {
          marginRight: 12
        }
      }), /*#__PURE__*/React.createElement(RaisedButton, {
        label: "Remove",
        secondary: true,
        onClick: this.handleRemoveBtnClick,
        disabled: this.state.removingUser
      })];
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ModalTopBar, {
        backUrl: "/org/".concat(this.props.organization.id, "/settings/users"),
        showCloseBtn: false,
        style: {
          position: 'static',
          marginBottom: 8
        },
        backLabel: "View All Users"
      }), haveRightDetails ? this.renderTeamMemberDetails(details) : /*#__PURE__*/React.createElement("div", {
        style: {
          height: 100,
          position: 'relative'
        }
      }, /*#__PURE__*/React.createElement(Spinner, {
        center: true
      })), details && details.orgStatus !== 'INACTIVE' ? !details.isOrgOwner ? /*#__PURE__*/React.createElement("div", {
        className: styles.removeWrap
      }, /*#__PURE__*/React.createElement("h2", {
        className: styles.removeHeader
      }, "Remove ", details.name), /*#__PURE__*/React.createElement("p", {
        className: styles.removeText
      }, "This will remove ", details.name, " from your team."), /*#__PURE__*/React.createElement(RaisedButton, {
        backgroundColor: "transparent",
        buttonStyle: {
          border: '2px solid #c71212',
          height: 36
        },
        labelStyle: {
          color: '#c71212'
        },
        label: "Remove ".concat(details.name.split(' ')[0]),
        onClick: function onClick() {
          return _this2.setState({
            showRemoveConfirmModal: true
          });
        }
      })) : /*#__PURE__*/React.createElement("div", {
        className: styles.removeWrap
      }, /*#__PURE__*/React.createElement("h2", {
        className: styles.removeHeader
      }, "Client Owner"), /*#__PURE__*/React.createElement("p", {
        className: styles.removeText
      }, details.name, " is the owner of this client and cannot be removed.")) : null, /*#__PURE__*/React.createElement(Dialog, {
        actionsContainerStyle: {
          borderTop: 0,
          padding: '5px 20px 20px 20px'
        },
        title: "Are You Sure?",
        titleStyle: {
          color: this.props.theme.colors.primaryColor
        },
        actions: modalActions,
        autoScrollBodyContent: true,
        modal: true,
        open: this.state.showRemoveConfirmModal,
        onRequestClose: this.handleModalClose,
        bodyStyle: {
          color: '#717171',
          lineHeight: '24px'
        }
      }, modalBodyContent), /*#__PURE__*/React.createElement(Snackbar, {
        message: this.state.snackbarMessage,
        open: this.state.showSnackbar,
        autoHideDuration: 4000
      }));
    }
  }]);

  return OrgUserDetail;
}(Component), _defineProperty(_class2, "propTypes", {
  name: PropTypes.string,
  email: PropTypes.string,
  joinDate: PropTypes.any
}), _temp)) || _class);
export default OrgUserDetail;